import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { PodService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetAssetsResolver implements Resolve<any> {

  constructor(@Inject(PodService) public podService: PodService) { }

  resolve() {
    return this.podService.getAssets();
  }
}
